export default __webpack_public_path__ + "static/media/404.c236abe3.png";